var ANNUAL_INTEREST_RATE = 9.49;
var DFI_PERCENT = 0.005;
var DOWN_PAYMENT_MIN_PERCENT = 20;
var DOWN_PAYMENT_DEFAULT_PERCENT = 25;
var DOWN_PAYMENT_SUBTRACT_VALUE = 20000;
var MANAGEMENT_VALUE = 25;
var MIN_SALE_PRICE = 22000;
var MIN_AGE = 18;
var MAX_AGE = 79;
var MIN_LOAN_TERM = 1;
var MAX_LOAN_TERM = 35;
var MONTHS_OF_YEARS = 12;
var MONTHLY_HOUSEHOLD_INCOMES_PERCENT = 0.3;
var MPI_LIST = [{
  valid: function valid(num) {
    return num <= 31;
  },
  rate: 0.017
}, {
  valid: function valid(num) {
    return num >= 32 && num <= 36;
  },
  rate: 0.021
}, {
  valid: function valid(num) {
    return num >= 37 && num <= 41;
  },
  rate: 0.026
}, {
  valid: function valid(num) {
    return num >= 42 && num <= 46;
  },
  rate: 0.04
}, {
  valid: function valid(num) {
    return num >= 47 && num <= 51;
  },
  rate: 0.055
}, {
  valid: function valid(num) {
    return num >= 52 && num <= 56;
  },
  rate: 0.17
}, {
  valid: function valid(num) {
    return num >= 57 && num <= 61;
  },
  rate: 0.213
}, {
  valid: function valid(num) {
    return num >= 62 && num <= 66;
  },
  rate: 0.384
}, {
  valid: function valid(num) {
    return num >= 67 && num <= 71;
  },
  rate: 0.484
}, {
  valid: function valid(num) {
    return num >= 72;
  },
  rate: 0.71
}];

export { ANNUAL_INTEREST_RATE, DFI_PERCENT, DOWN_PAYMENT_DEFAULT_PERCENT, DOWN_PAYMENT_MIN_PERCENT, DOWN_PAYMENT_SUBTRACT_VALUE, MANAGEMENT_VALUE, MAX_AGE, MAX_LOAN_TERM, MIN_AGE, MIN_LOAN_TERM, MIN_SALE_PRICE, MONTHLY_HOUSEHOLD_INCOMES_PERCENT, MONTHS_OF_YEARS, MPI_LIST };
